import { Link } from "@hyperapp/router";
import { h } from "hyperapp";
import queryString from "query-string";

import { format } from "date-fns";
import jQuery from "jquery";

import listCSS from "./list.css";

import { addressRenderer } from "../../common/address-renderer/address-renderer";
import { columnIsSelected } from "../../common/column-selector/utils/column-is-selected";
import { contactRenderer } from "../../common/contact-renderer/contact-renderer";
import { areAllSelected } from "../../common/list-item-selector/utils/are-all-selected";
import { portifoliosRenderer } from "../../common/portifolios-renderer/portifolios-renderer";
import { iconWithTooltip } from "../../common/icon-with-tooltip/icon-with-tooltip";
import { PlaceTag } from "./place-tag";
import { mainTooltip } from "../../common/main-tooltip/main-tooltip";
import { secondaryTooltip } from "../../common/secondary-tooltip/secondary-tooltip";

export const list = ({
  actions,
  section,
  state,
  translations,
}): JSX.Element => {
  const { setAllSelected, setSelected } = actions;

  const { categories } = state;

  const { columns, items, radius, selected, since } = state[section];

  const getTranslatedStatus = index => {
    const translatedStatus = {
      [index]: "...",
      positioned: "posicionado",
      valid: "válido",
      not_positioned: "não posicionado",
      imported: "importado",
    };

    return translatedStatus[index];
  };

  return (
    <div class="table-responsive card">
      <table style="position:relative;" class="table">
        <thead class="">
          <tr>
            <th class={listCSS.singleIconColumn}>
              <div class="custom-control custom-checkbox">
                <input
                  class="custom-control-input"
                  checked={areAllSelected({ items, selected })}
                  disabled={items.length === 0}
                  id="selectAllItemsOnCurrentPage"
                  onchange={event =>
                    setAllSelected({ section, select: event.target.checked })
                  }
                  type="checkbox"
                />
                <label
                  class="custom-control-label"
                  for="selectAllItemsOnCurrentPage"
                />
              </div>
            </th>

            <th scope="col">{translations["name"]}</th>
            {columnIsSelected({ columnID: "address", columns }) && (
              <th scope="col">{translations["address"]}</th>
            )}
            {columnIsSelected({ columnID: "category", columns }) && (
              <th scope="col">{translations["category"]}</th>
            )}

            {columnIsSelected({ columnID: "cnpj_cpf", columns }) && (
              <th scope="col">{translations["CNPJ"]}</th>
            )}
            {columnIsSelected({ columnID: "last_visit", columns }) && (
              <th scope="col">{translations["lastVisit"]}</th>
            )}
            {columnIsSelected({ columnID: "contacts", columns }) && (
              <th scope="col">{translations["contact"]}</th>
            )}
            {columnIsSelected({ columnID: "corporate_name", columns }) && (
              <th scope="col">{translations["companyName"]}</th>
            )}
            {columnIsSelected({ columnID: "status", columns }) && (
              <th scope="col">{translations["status"]}</th>
            )}
            {columnIsSelected({ columnID: "portifolios", columns }) && (
              <th scope="col">{translations["portifolios"]}</th>
            )}
            {columnIsSelected({ columnID: "id", columns }) && (
              <th scope="col">ID</th>
            )}
            <th scope="col">Agendamento</th>

            <th style="min-width:170px;" scope="col">
              {translations["nearPlaces"]}{" "}
              {secondaryTooltip({
                text: translations["findNearPlaces"],
              })}
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map(
            ({
              address,
              category_id: categoryID,
              cnpj_cpf: cnpjCPF,
              contacts,
              corporate_name: corporateName,
              id,
              last_pending_schedule,
              last_completed_visit,
              location,
              name,
              portifolios,
              status,
            }) => {
              const category = categories.find(
                category => category.id === categoryID,
              );

              const isSelected =
                selected.findIndex(item => item.id === id) !== -1;

              return (
                <tr
                  class={isSelected ? "table-info" : ""}
                  onclick={() =>
                    setSelected({
                      section,
                      select: !isSelected,
                      value: id,
                    })
                  }
                  style="cursor: pointer;"
                >
                  <td class={listCSS.singleIconColumn}>
                    <div class="custom-control custom-checkbox">
                      <input
                        checked={isSelected}
                        class="custom-control-input"
                        id={id}
                        onchange={() =>
                          setSelected({
                            section,
                            select: !isSelected,
                            value: id,
                          })
                        }
                        type="checkbox"
                        value={id}
                      />
                      <label class="custom-control-label" for={id} />
                    </div>
                  </td>
                  <td scope="row">
                    <div>{name}</div>
                  </td>
                  {columnIsSelected({ columnID: "address", columns }) &&
                    (address ? (
                      <td>
                        <div>{addressRenderer({ address })}</div>
                      </td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <div>
                          <i>Sem endereço</i>
                        </div>
                      </td>
                    ))}
                  {columnIsSelected({ columnID: "category", columns }) &&
                    (category ? (
                      <td>
                        <div>{category.name}</div>
                      </td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <div>
                          <i>Não categorizado</i>
                        </div>
                      </td>
                    ))}
                  {columnIsSelected({ columnID: "cnpj_cpf", columns }) && (
                    <td style="white-space: nowrap;">
                      <div>{cnpjCPF}</div>
                    </td>
                  )}
                  {columnIsSelected({ columnID: "last_visit", columns }) && (
                    <td style="white-space: nowrap;">
                      {last_completed_visit ? (
                        /* DD = dia do mês para versão do date-fns utilizada (1.30.1); */
                        <div>{format(last_completed_visit, "DD/MM/YYYY")}</div>
                      ) : (
                        <div style={{ color: "#999", fontStyle: "italic" }}>
                          {translations["neverVisited"]}
                        </div>
                      )}
                    </td>
                  )}
                  {columnIsSelected({ columnID: "contacts", columns }) &&
                    (contacts ? (
                      <td>
                        <div>{contactRenderer({ contacts })}</div>
                      </td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <div>
                          <i>Sem contato</i>
                        </div>
                      </td>
                    ))}
                  {columnIsSelected({
                    columnID: "corporate_name",
                    columns,
                  }) && (
                    <td>
                      <div>{corporateName}</div>
                    </td>
                  )}
                  {columnIsSelected({ columnID: "status", columns }) && (
                    <td>
                      <div>{getTranslatedStatus(status)}</div>
                    </td>
                  )}
                  {columnIsSelected({ columnID: "portifolios", columns }) &&
                    (portifolios && portifolios.length > 0 ? (
                      <td>
                        <div>{portifoliosRenderer({ portifolios })}</div>
                      </td>
                    ) : (
                      <td class={listCSS.uncategorized}>
                        <div>
                          <i>Sem carteira</i>
                        </div>
                      </td>
                    ))}

                  {columnIsSelected({ columnID: "id", columns }) && (
                    <td>
                      <div>
                        <span class={listCSS.uuid}>{id}</span>
                      </div>
                    </td>
                  )}

                  <td>
                    <div>
                      {last_pending_schedule ? (
                        <span>
                          {iconWithTooltip({
                            text: `Já existe uma Visita agendada neste Local para <br /> o dia ${format(
                              last_pending_schedule,
                              "DD/MM/YYYY",
                            )} às ${format(last_pending_schedule, "HH:mm")}`,
                            icon: "clock",
                          })}
                        </span>
                      ) : (
                        <span />
                      )}
                    </div>
                  </td>
                  <td>
                    <div>
                      {location ? (
                        // Link(
                        //   {
                        //     to: `unvisited-places/nearby?${queryString.stringify(
                        //       {
                        //         coordinates: `${location.x},${location.y}`,
                        //         id,
                        //         name,
                        //         radius,
                        //         since,
                        //       },
                        //     )}`,
                        //   },
                        //<span>
                        state.unvisitedPlaces.selectedPlace &&
                        state.unvisitedPlaces.hasSelectedAPlace &&
                        state.unvisitedPlaces.selectedPlace.id === id ? (
                          PlaceTag({ actions })
                        ) : (
                          <span
                            onclick={event => {
                              event.stopPropagation();
                              actions.setSelectedPlace({
                                place: {
                                  id,
                                  name,
                                  radius,
                                  since,
                                  coordinates: `${location.x},${location.y}`,
                                },
                              });
                              actions.setHasSelectedPlace(true);
                              actions.fetchUnvisitedPlacesNearby();
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                            >
                              <path
                                d="M15.7812 14.3344L12.6656 11.2188C12.525 11.0781 12.3344 11 12.1344 11H11.625C12.4875 9.89688 13 8.50937 13 7C13 3.40937 10.0906 0.5 6.5 0.5C2.90937 0.5 0 3.40937 0 7C0 10.5906 2.90937 13.5 6.5 13.5C8.00937 13.5 9.39688 12.9875 10.5 12.125V12.6344C10.5 12.8344 10.5781 13.025 10.7188 13.1656L13.8344 16.2812C14.1281 16.575 14.6031 16.575 14.8938 16.2812L15.7781 15.3969C16.0719 15.1031 16.0719 14.6281 15.7812 14.3344ZM6.5 11C4.29063 11 2.5 9.2125 2.5 7C2.5 4.79063 4.2875 3 6.5 3C8.70938 3 10.5 4.7875 10.5 7C10.5 9.20938 8.7125 11 6.5 11Z"
                                fill="#1A69AD"
                              />
                            </svg>
                          </span>
                        )
                      ) : //  {PlaceTag()}
                      //</div>  </span>,
                      //  )
                      state.selectedPlace && state.selectedPlace.id === id ? (
                        PlaceTag({ actions })
                      ) : (
                        <i
                          class="material-icons"
                          data-placement="top"
                          title="Local não posicionado"
                        >
                          location_off
                        </i>
                      )}
                    </div>
                  </td>
                </tr>
              );
            },
          )}
        </tbody>
      </table>
    </div>
  );
};
